import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function LogoDesigning() {

    const logoSteps = [
        { number: "01", title: "Brand Discovery & Consultation", description: "analyze your brand values, audience, and competitors to create a design brief.", icon: "📤" },
        { number: "02", title: "Concept Design & Drafts", description: "Our designers create multiple logo concepts for review and refinement.", icon: "⚡" },
        { number: "03", title: "Final Logo Development", description: "We finalize your logo, ensuring scalability, color accuracy, and usability.", icon: "✓" },
        { number: "04", title: "Delivery & Brand Guidelines", description: "Receive your logo in multiple formats along with usage guidelines for consistent branding.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Logo Design Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Creative logo design services in Los Angeles, CA. Get unique, professional logos for your business and brand identity." />
                <meta name="keywords" content="logo design services, custom logo design, professional logo designers, logo design Los Angeles, logo design near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Logo Designing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Logo Designing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/logo1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Creative Identity. Lasting Impression.</span>
                                <h3 className="case-study-title">Professional Logo Designing in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide custom logo designing services in Los Angeles, California, helping businesses establish a strong and recognizable brand identity. A professionally designed logo is the cornerstone of your branding, creating lasting impressions with customers and setting your business apart from competitors.
                                </p>
                                <p className="case-study-description">
                                    Our experienced design team crafts unique, memorable logos that reflect your brand values, target audience, and industry trends. Whether you need a minimalist icon, bold typography, or intricate illustrations, our logo designing services ensure your brand communicates professionalism, credibility, and creativity. If you’re searching for logo designing near you in Los Angeles, Grand Indigo Embroidery delivers standout logos tailored to your business needs.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Designed for Versatility & Impact</span>
                                <h3 className="case-study-title">Custom Logo Solutions for Businesses</h3>
                                <p className="case-study-description">
                                    We offer tailored logo design solutions for startups, small businesses, corporations, and personal brands. From initial concepts and sketches to final digital files, we ensure your logo is versatile, scalable, and ready for all print or digital applications. Our process integrates feedback at every stage, making sure the final logo aligns perfectly with your brand vision. You can also order logo designing services online and receive professional, production-ready files for immediate use.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/logo2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={logoSteps} />


             <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What types of logos can you design?"
                                    answer="We create text-based, icon-based, combination, and illustrative logos tailored to your brand."
                                />

                                <FaqItem
                                    question="Do you offer logo designing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional logo designing services in Los Angeles, California."
                                />

                                <FaqItem
                                    question="Can you redesign an existing logo?"
                                    answer="Absolutely. We can refresh or completely redesign existing logos while keeping your brand identity intact."
                                />

                                <FaqItem
                                    question="How long does it take to create a logo?"
                                    answer="Most logo projects are completed within 1–3 weeks depending on complexity and revisions."
                                />

                                <FaqItem
                                    question="Can I order logo designing services online?"
                                    answer="Yes, you can order logo designing services online and receive professional files ready for use in print or digital media."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
